import $ from "jquery";
import { debounce, isOverflown } from "../utils/functions";
var $window = $(window);
var $document = $(document);
$document.on("click", "[data-tab-button]", function () {
    var $thisEL = $(this).parent();
    var id = $thisEL.attr("data-id");
    /* ------------------------------------------------------ */
    var $block = $thisEL.closest("[data-tab-block]");
    var $listItems = $block.find("[data-tab-item]");
    var $listItem = $listItems.filter(function () {
        return $(this).attr("data-id") === id;
    });
    var $tabs = $block.find("[data-tab]");
    var $tab = $tabs.filter(function () {
        return $(this).attr("data-id") === id;
    });
    /* ------------------------------------------------------ */
    var hideAllTabs = function () {
        $listItems.attr("data-selected", "false");
        $tabs.attr("hidden", "").attr("aria-hidden", "true");
    };
    var showTab = function () {
        $listItem.attr("data-selected", "true");
        $tab.removeAttr("hidden aria-hidden");
    };
    /* ------------------------------------------------------ */
    hideAllTabs();
    showTab();
});
$("[data-tab-block]").each(function () {
    var _a;
    var $block = $(this);
    var id = $block.attr("data-id");
    /* ------------------------------------------------------ */
    var $list = $block.find("[data-tab-list]");
    /* ------------------------------------------------------ */
    var isScrolledLeft = function () { return $list.scrollLeft() === 0; };
    var isScrolledRight = function () {
        var _a, _b;
        return Math.ceil(((_a = $list.scrollLeft()) !== null && _a !== void 0 ? _a : 0) + ((_b = $list.outerWidth()) !== null && _b !== void 0 ? _b : 0)) >=
            Math.ceil($list[0].scrollWidth);
    };
    var handleScroll = function () {
        if (isScrolledLeft() && isScrolledRight()) {
            $block.addClass("is-scrolled-left is-scrolled-right");
        }
        else {
            isScrolledLeft()
                ? $block.addClass("is-scrolled-left")
                : $block.removeClass("is-scrolled-left");
            isScrolledRight()
                ? $block.addClass("is-scrolled-right")
                : $block.removeClass("is-scrolled-right");
        }
    };
    /* ------------------------------------------------------ */
    var down = false;
    var scrollLeft = 0;
    var x = 0;
    $window.on("resize:width.".concat(id), debounce(handleScroll));
    $list.on({
        scroll: handleScroll,
        mousedown: function (event) {
            down = true;
            scrollLeft = this.scrollLeft;
            x = event.clientX;
        },
        mousemove: function (event) {
            if (down) {
                this.scrollLeft = scrollLeft + x - event.clientX;
            }
        },
        mouseup: function () { return (down = false); },
        mouseleave: function () { return (down = false); },
    });
    (_a = $list.get(0)) === null || _a === void 0 ? void 0 : _a.addEventListener("wheel", function (event) {
        if (isOverflown(this)) {
            event.preventDefault();
            this.scrollLeft += event.deltaY;
        }
    });
    handleScroll();
});
